export default "__VITE_ASSET__ByN9vRl8__"